import { Component, input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { RuleGroup } from 'src/app/shared/interfaces/holidays.interface';

@Component({
  selector: 'app-rule-group-card',
  standalone: true,
  imports: [MatIconModule, MatDividerModule],
  templateUrl: './rule-group-card.component.html',
  styleUrls: ['./rule-group-card.component.css', '../../../styles/layout.css'],
})
export class RuleGroupCardComponent {
  // input signal coming from the parent
  readonly ruleGroup = input<RuleGroup | null>();

  constructor(private router: Router) {}

  goToRuleGroup() {
    const ruleGroup = this.ruleGroup();
    if (!ruleGroup?.id) return;

    // Navigate to rule group edit page
    this.router.navigate([
      '/home/vacations/protocols/rule-group',
      ruleGroup.id,
      'edit',
    ]);
  }
}
